import React from 'react';
import { motion } from "motion/react";

const SearchAndFilterBar: React.FC = () => {
    const containerVariants = {
        hidden: { opacity: 0, y: -20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                staggerChildren: 0.1,
                delayChildren: 0.1,
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: -10 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.4,
            },
        },
    };

    const buttonVariants = {
        hover: {
            scale: 1.02,
            transition: {
                duration: 0.2,
            },
        },
        tap: {
            scale: 0.98,
        },
    };

    return (
        <section className="bg-white/80 dark:bg-black/80 backdrop-blur-xl border-y border-gray-200/50 dark:border-gray-800/50 sticky top-[89px] z-30">
            <motion.div 
                className="max-w-8xl mx-auto py-6 px-8"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <div className="flex items-center justify-between flex-wrap gap-4">
                    <motion.div 
                        className="flex items-center gap-6"
                        variants={itemVariants}
                    >
                        <h2 className="text-lg font-serif font-medium text-gray-900 dark:text-white">Find Your Night</h2>
                    </motion.div>
                    <motion.div 
                        className="flex items-center gap-3 flex-wrap"
                        variants={itemVariants}
                    >
                        <motion.div 
                            className="relative"
                            variants={itemVariants}
                        >
                            <input 
                                type="text" 
                                placeholder="Search club or event..." 
                                className="w-64 bg-gray-100/50 dark:bg-gray-900/50 border border-gray-300 dark:border-gray-700 rounded-full py-3 pl-5 pr-12 text-sm text-gray-900 dark:text-white placeholder:text-gray-500 dark:placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-all duration-300" 
                            />
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 absolute right-4 top-3.5 text-gray-400"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>
                        </motion.div>
                        {/* Add dropdowns for city, date etc. here */}
                         <motion.button 
                            className="px-5 py-3 bg-blue-600 text-white border border-blue-500 rounded-full text-sm font-medium hover:bg-blue-500 transition-all duration-300"
                            variants={buttonVariants}
                            whileHover="hover"
                            whileTap="tap"
                        >
                            Search
                        </motion.button>
                    </motion.div>
                </div>
            </motion.div>
        </section>
    );
};

export default SearchAndFilterBar;
